/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'picto-indifferent': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" class="st0" d="M22.9 30.1L1.5 8.6c-2-2-2-5.2 0-7.2s5.2-2 7.2 0l21.4 21.4c2 2 2 5.2 0 7.2s-5.2 2-7.2.1"/><path pid="1" class="st0" d="M1.5 30.1c-2-2-2-5.2 0-7.2L22.9 1.5c2-2 5.2-2 7.2 0s2 5.2 0 7.1L8.6 30.1c-1.9 2-5.1 1.9-7.1 0"/>'
  }
})
